import React from 'react';
import { compose } from 'redux';
import { withMountListener } from '@beef/react/enhancers';
import { View } from "./components/View";
import { Layout } from "./components/Layout";
import { BreakpointProviderRC, LayoutContainerRC, LayoutRC, MenuRC, RegionRC, ShareButtonRC } from "./connected";
import { RegionModalRC } from "./components/RegionModal";
import { MenuModalRC } from "./components/MenuModal";
import { withMetricContainer } from "./metric";
import { LogoRC } from "./components/Logo/connected";
import { MobileAppBannerRC } from "./components/MobileAppBanner/connected";
import { authConnector, mountConnector } from "./connectors";
var Header = function Header() {
  return /*#__PURE__*/React.createElement(BreakpointProviderRC, {
    "data-t-id": "layouts-Header"
  }, /*#__PURE__*/React.createElement(LayoutRC, {
    "data-t-id": "layouts-Header"
  }, /*#__PURE__*/React.createElement(LayoutContainerRC, {
    transparent: true,
    "data-t-id": "layouts-Header"
  }, /*#__PURE__*/React.createElement(Layout.Indent, null, /*#__PURE__*/React.createElement(View.Desktop, null, /*#__PURE__*/React.createElement(Layout.Section, null, /*#__PURE__*/React.createElement(Layout.Wrapper, {
    gap: "m",
    position: "start"
  }, /*#__PURE__*/React.createElement(MenuRC, null), /*#__PURE__*/React.createElement(RegionRC, null)), /*#__PURE__*/React.createElement(Layout.Wrapper, {
    position: "center"
  }, /*#__PURE__*/React.createElement(LogoRC, null)), /*#__PURE__*/React.createElement(Layout.Wrapper, {
    gap: "m",
    position: "end"
  }, /*#__PURE__*/React.createElement(ShareButtonRC, null)))), /*#__PURE__*/React.createElement(View.Mobile, null, /*#__PURE__*/React.createElement(Layout.Wrapper, {
    position: "start"
  }, /*#__PURE__*/React.createElement(RegionRC, null), /*#__PURE__*/React.createElement(MobileAppBannerRC, null)), /*#__PURE__*/React.createElement(Layout.Section, null, /*#__PURE__*/React.createElement(Layout.Wrapper, {
    position: "start"
  }, /*#__PURE__*/React.createElement(MenuRC, null)), /*#__PURE__*/React.createElement(Layout.Wrapper, {
    position: "center"
  }, /*#__PURE__*/React.createElement(LogoRC, null)), /*#__PURE__*/React.createElement(Layout.Wrapper, {
    position: "end"
  }, /*#__PURE__*/React.createElement(ShareButtonRC, null)))), /*#__PURE__*/React.createElement(MenuModalRC, null), /*#__PURE__*/React.createElement(RegionModalRC, null)))));
};
export var HeaderPromoRC = compose(authConnector, mountConnector, withMountListener, withMetricContainer, React.memo)(Header);